
const intitalState = {
  weather: null,
  loadingWeather: false
};

export const weatherReducers = (state = intitalState, action) => {
  switch (action.type) {

    case "GET_WEATHER_LOADING":
      return {
        ...state,
        loadingWeather: true,
        weather: null
      };

    case "GET_WEATHER_SUCCESS":
      return {
        ...state,
        weather: action.weather,
      };

    default:
      return state;
  }
};
